export default function Loader(props) {
    return (
        <div className='relative uppercase font-extrabold text-3xl'>
            <div className='absolute' >Loading</div>
            <div className='animate-ping opacity-50' >Loading</div>
        </div>
    );
}
